// it's put into separate module to avoid polluting widget lazy component, which uses this id to start app load
export const FEDOPS_LOGGER_ID = 'cashier-payments-widget';
